// extracted by mini-css-extract-plugin
export default {"InfoList":"CancellationPolicy-module__InfoList--PQc0O","img":"CancellationPolicy-module__img--KwaxW"};